import React from "react";


function Accommodation() {
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/accommodation2.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>
                {/* <h3 style={{fontWeight:'600',fontSize:'15pt',lineHeight:'24pt',color:'maroon'}}>
            Accommodation facility will be <span style={{color:'red',fontSize:'18pt'}}>UNAVAILABLE</span>  in Panchajanyam Guest House, AC Dormitory, Non-AC Dormitory, Nelppura Hall from 15th Nov 2025 to 20th Jan 2026 due to the Murajapam Lakshadeepam Festival
        </h3>
        <hr /> */}
                <h3 style={{ marginBottom: '25px', fontWeight: '600' }}>Accommodation Facilities available for Devotees</h3>
                <div className="row">
                    <div className="col-md-12" style={{ background: '#fffefd', padding: '50px' }}>
                        <div class="table-responsive">
                            <table class="table ">
                                <thead>
                                    <tr>
                                        <th>Sl. No</th>
                                        <th>Place</th>
                                        <th>Rate per person / 24 hrs (With Bed) &nbsp;(1 bed, 2 bed sheet, 1 pillow)</th>
                                        <th>Rate per person / 24 hrs (With Mat)&nbsp;(1 mat, 2 bed sheet, 1 pillow)</th>
                                        <th>Maximum No of Persons allowed</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td data-label="Sl. No">1</td>
                                        <td data-label="Place">Nelpura Hall (Wooden floor)</td>
                                        <td data-label="Rate (With Bed)">Rs.250/- per person</td>
                                        <td data-label="Rate (With Mat)">Rs.200/- per person</td>
                                        <td data-label="Max Persons">150</td>
                                    </tr>

                                    <tr>
                                        <td data-label="Sl. No">2</td>
                                        <td data-label="Place">Nelpura Front (Marble floor Mugappu)</td>
                                        <td data-label="Rate (With Bed)">Rs.250/- per person</td>
                                        <td data-label="Rate (With Mat)">Rs.200/- per person</td>
                                        <td data-label="Max Persons">40</td>
                                    </tr>

                                    <tr>
                                        <td data-label="Sl. No">3</td>
                                        <td data-label="Place">Old Store Room</td>
                                        <td data-label="Rate (With Bed)">Rs.250/- per person</td>
                                        <td data-label="Rate (With Mat)">Rs.200/- per person</td>
                                        <td data-label="Max Persons">10</td>
                                    </tr>

                                    <tr>
                                        <td data-label="Sl. No">4</td>
                                        <td data-label="Place">Upstairs Hall</td>
                                        <td data-label="Rate (With Bed)">Rs.250/- per person</td>
                                        <td data-label="Rate (With Mat)">Rs.200/- per person</td>
                                        <td data-label="Max Persons">20</td>
                                    </tr>

                                    <tr>
                                        <td data-label="Sl. No">5</td>
                                        <td data-label="Place">Front Hall</td>
                                        <td data-label="Rate (With Bed)">Rs.250/- per person</td>
                                        <td data-label="Rate (With Mat)">Rs.200/- per person</td>
                                        <td data-label="Max Persons">50</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-md-4" style={{ backgroundImage: 'url(./images/event.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                </div>


            </div>
        </div>
    );
}

export default Accommodation;